var _defs, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssigner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.92 104.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#2c8ffe;}.cls-2{stroke:#fff;stroke-width:2.79px;}.cls-2,.cls-3{stroke-linecap:round;stroke-miterlimit:10;}.cls-3{fill:none;stroke:#2c8ffe;stroke-width:5.58px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.51,77.18V71.7A18.61,18.61,0,0,0,74.9,53.08H52A18.61,18.61,0,0,0,33.41,71.7v5.48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.94,63.25l3.48,6.92a2.43,2.43,0,0,0,1.83,1.31L79,72.58a2.43,2.43,0,0,1,1.33,4.16L74.78,82a2.42,2.42,0,0,0-.72,2.17l1.31,7.5a2.43,2.43,0,0,1-3.5,2.58l-7-3.6a2.44,2.44,0,0,0-2.23,0l-7,3.6a2.43,2.43,0,0,1-3.51-2.58l1.31-7.5A2.41,2.41,0,0,0,52.77,82l-5.52-5.28a2.43,2.43,0,0,1,1.34-4.16l7.71-1.1a2.41,2.41,0,0,0,1.82-1.31l3.48-6.92A2.43,2.43,0,0,1,65.94,63.25Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 63.77,
    cy: 28.12,
    r: 18.5,
    transform: "translate(6.32 67.59) rotate(-58.28)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigner);
export default __webpack_public_path__ + "static/media/Assigner.e8e73303621888d46a98ec3649dd5013.svg";
export { ForwardRef as ReactComponent };